// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2jT9C","label":"Completed_label__AuX9E"};